import React, { memo } from "react";
import { Handle, Position, NodeResizer } from "@xyflow/react";

const RedeEquatorial = ({ data, selected }: any) => {
  return (
    <div
      style={{
        position: "relative",
        width: "200px",
        height: "50px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ff0000",
        borderRadius: "4px",
        border: "1px solid #ff0000",
        padding: "5px",
        color: "#fff",
        fontWeight: "bold",
      }}
    >
      {/* Exibindo o rótulo */}
      <div style={{ marginBottom: "5px" }}>
        {data.label || "REDE EQUATORIAL"}
      </div>

      {/* Handle para conexões apenas na parte inferior */}
      <Handle
        type="target"
        position={Position.Bottom}
        id="bottom"
        style={{ backgroundColor: "#0077ff" }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="bottom"
        style={{ backgroundColor: "#0077ff" }}
      />
    </div>
  );
};

export default memo(RedeEquatorial);
